import React, { useEffect, useState, Fragment } from "react";
import Loader from "../../UI/loader";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel, toBool } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { createRestaurantReservationV2, get7roomsRestaurantReservationData, getMyReservationData, updateRestaurantReservationV2 } from "../../../action/resReservationV2";
import ResReservationV2_0 from "./resReservationV2_0";
import ResReservationV2_1 from "./resReservationV2_1";
import ResReservationV2_2 from "./resReservationV2_2";
import MyReservationV2 from "./myReservationV2";
import ResReservationV2_success from "./resReservationV2_success";
import ResReservationV2_update from "./resReservationV2_update";
import DailyProgramAckPopupV2 from "./dailyProgramAckPopupV2";


const ResReservationV2 = (props) => {

    const { t } = props;

    let room = localStorage.getItem("room");
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("resReservationV2SessionToken");


    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const [loading, setLoading] = useState(false);
    const [displayLoadingMsg, setDisplayLoadingMessage] = useState("");

    const [currentPage, setCurrentPage] = useState(0);

    const [fetchingMyReservation, setFetchingMyReservation] = useState(false);
    const [myReservationData, setMyReservationData] = useState([]);

    const [selectedMyReservationData, setSelectedMyReservationData] = useState({});

    const [resVenueData, setResVenueData] = useState([]);

    const [selectedVenueData, setSelectedVenueData] = useState({});
    const [selectedVenueId, setSelectedVenueId] = useState(null);

    const [preferredVenueDetails, sePreferredVenueDetails] = useState({})
    const [askDailyProgramAck, setAskDailyProgramAck] = useState(false);
    const [askDailyProgramAckMsg, setAskDailyProgramAckMsg] = useState("");


    const handleDailyProgramAck = () => {
        sePreferredVenueDetails({...preferredVenueDetails, dailyProgramAck: true});
        setAskDailyProgramAck(false);

        handleCreateReservation({...preferredVenueDetails, dailyProgramAck: true});
    }

    const handleReservationSuccessNext = () => {
        handleNext();
    }

    const handleProceedMakeReservation = () => {
        handleNext();
    }

    const handleVenueNextScreen1 = (selectedVenueData) => {

        setSelectedVenueData(selectedVenueData)
        setSelectedVenueId(selectedVenueData.id)

        handleNext();
    }


    const handleNext = () => {

        if(currentPage == 0){
            setCurrentPage(1);
            return
        }

        if(currentPage == 1){
            setCurrentPage(2);
            return
        }

        // handle success create reservation
        if(currentPage == 3){
            setCurrentPage(1);
            return
        }
    }


    const handleGoBack = () => {

        if (currentPage == 4) {
            setCurrentPage(1);
            return;
        }

        if (currentPage == 2) {
            setCurrentPage(1);
            return;
        }

        if(currentPage == 1){
            if(resVenueData.length > 1){
                setCurrentPage(0);
                return;
            }
        }

        props.setGoHome(true);
    }

    const handleEditReservation = (editReservationData) => {
        setSelectedMyReservationData(editReservationData);

        setCurrentPage(4);
    }

    const handleDeleteReservation = (bool) => {
        
        if(bool){
            fetchMyReservation(4);
            props.closeOrderPopUp(true,t('resReservationV2.success.successful_res_cancelled'), "", false)
        } else {
            props.closeOrderPopUp(true,t('resReservationV2.errors.error_cancelling_reser'), "", true)
        }
    }

    const proceedUpdateReservation = (updateReservationPayload) => {

        setLoading(true);
        setDisplayLoadingMessage("Updating Reservation...")

        updateRestaurantReservationV2(updateReservationPayload)
            .then((res) => {

                if(res.status == 200){

                    fetchMyReservation(4);
                    setCurrentPage(1);
                    setLoading(false);

                    props.closeOrderPopUp(true, t('resReservationV2.success.thank_you'), t('resReservationV2.success.successful_res_update'),false);


                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType, 
                        "UPDATE RESERVATION - SUCCESS", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId }, 
                        0, 
                        props.guestIsLoggedIn
                    );

                } else {
                    setLoading(false);

                    if(res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg){
                        props.closeOrderPopUp(true, res.response.data.header.status.msg , "", true)
                    } else {
                        props.closeOrderPopUp(true, t('resReservationV2.errors.error_updating_reser'), "", true)
                    }

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "UPDATE RESERVATION - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg)  }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => { console.log(err); setLoading(false); props.closeOrderPopUp(true, t('resReservation.errors.error_updating_reser'), "", true) })
    }

    const handleCreateReservation = (requestVenueDetails) => {

        setLoading(true);
        setDisplayLoadingMessage("Creating Reservation...")

        let requestPayload = {
            "venueId" : selectedVenueId,
            "firstName" : requestVenueDetails.firstName,
            "lastName" : requestVenueDetails.lastName,
            "email" : requestVenueDetails.email,
            "phoneNumber": requestVenueDetails.phoneNumber,
            "guestCount" : requestVenueDetails.guestCount,
            "date" : requestVenueDetails.date,
            "reservationTime" : requestVenueDetails.reservationTime,
            "guestComment" : requestVenueDetails.guestComment,
            "shiftCategory" : requestVenueDetails.shiftCategory,
            "dailyProgramAck" : requestVenueDetails.dailyProgramAck
        }
        sePreferredVenueDetails(requestPayload);

        createRestaurantReservationV2(requestPayload)
            .then((res) => {
                setLoading(false)

                if(res.status == 200){

                    if(res.data.header && res.data.header.status && res.data.header.status.responseCode == 409){
                        setAskDailyProgramAck(true);
                        setAskDailyProgramAckMsg(res.data.header.status.msg)
                    } else {
                        localStorage.setItem("resReservationClientId", res.data.payload.data.client_id);
                        fetchMyReservation(4);
                        setCurrentPage(3);
                        sePreferredVenueDetails({});
                    }

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "CREATE RESERVATION - SUCCESS", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                } else {

                    if(res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg){
                        props.closeOrderPopUp(true, res.response.data.header.status.msg , "", true)
                    } else {
                        props.closeOrderPopUp(true, t('resReservationV2.errors.error_creating_reser'), "", true)
                    }


                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "CREATE RESERVATION - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg)  }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => { 
                setLoading(false); 
                props.closeOrderPopUp(true, t('resReservationV2.errors.error'), "", true)
            })
    }


    const filterMyResReservation = (data) => {

        if (!data || data.length === 0) {
            return [];
        }
    
        let myFilteredReservationData = data.filter(item => (!item.event || !item.event.event_id));

        return myFilteredReservationData;
    }

    
    const fetchMyReservation = (delay) => {

        setFetchingMyReservation(true);

        let timeDelay = (+delay * 1000) || 0;

        console.log(delay)
        setTimeout(() => {
        let clientId = localStorage.getItem("resReservationClientId")
        getMyReservationData(clientId)
        .then((res) => {
            setFetchingMyReservation(false);

            if (res.status == 200) {

                let myFilteredReservationData = filterMyResReservation(res.data.payload.data && res.data.payload.data.results);
                setMyReservationData(myFilteredReservationData);

                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType, 
                    "FETCH RESERVATION DETAILS - SUCCESS", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId}, 
                    0, 
                    props.guestIsLoggedIn
                );
            } else {
                
                props.closeOrderPopUp(true, t('resReservationV2.errors.error_fetching_reservation_details'), "", true);

                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType, 
                    "FETCH RESERVATION DETAILS - ERROR", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) }, 
                    0, 
                    props.guestIsLoggedIn
                );
            }
        })
        .catch((err) => { setFetchingMyReservation(false); props.closeOrderPopUp(true, t('resReservationV2.errors.error_fetching_reservation_details'), "", true); })
        }, timeDelay);
    }

    const fetchRestaurantReservationData = () => {

        setError(false);
        setLoading(true);

        get7roomsRestaurantReservationData()
            .then((res) => {
                if (res.status == 200) {
                    setResVenueData(res.data.payload.data && res.data.payload.data.results);
                    setLoading(false);

                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH RESERVATION DATA - SUCCESS",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                        0,
                        props.guestIsLoggedIn
                    );
                } else {
                    setLoading(false);
                    setError(true)
                    setErrorMsg(res.response && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg)


                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH RESERVATION DATA - ERROR",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                        0,
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => { setLoading(false); setError(true) })
    }


    const fetchData = async () => {
        fetchRestaurantReservationData();
        fetchMyReservation(0);
    };



    useEffect(() => {
        if (!loading) setDisplayLoadingMessage("");
    }, [loading])


    useEffect(() => {

        if(toBool(props.allowWalkInGuestRestaurantBooking)){
            fetchData();
        } else {
            if (room && room != "null") {
                fetchData();
            } else {
                if (process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
            }
        }

        if(!localStorage.getItem("resReservationClicked")){
            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                CLICKED,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                0,
                props.guestIsLoggedIn,
                () => localStorage.setItem("resReservationClicked", true)
            );
        }

        return () => {
            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                EXIT,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                0,
                props.guestIsLoggedIn
            );

        }
    }, [])


    return (
        <Fragment>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section className="widgets padding-0 margin-0 container-bg">

                {error ?
                    <SuccessFailScreen status={false} showTryAgain={true} showClose={true} statusMessage1={t(`resReservationV2.errors.error`)} statusMessage2={errorMsg || t('resReservationV2.errors.unable_process_request')} close={props.setGoHome} tryAgain={() => fetchData()} />
                    :
                    currentPage == 0 ?
                        <ResReservationV2_0 resVenueData={resVenueData} next={(SelectedVenueData) => handleVenueNextScreen1(SelectedVenueData)} goBack={() => handleGoBack()} />
                    : currentPage == 1 ?
                    <section class="widgets spa-listing">
                        <ResReservationV2_1 selectedVenueId={selectedVenueId} selectedVenueData={selectedVenueData} next={() => handleProceedMakeReservation()} goBack={() => handleGoBack()} />
                        <MyReservationV2 selectedVenueId={selectedVenueId} fetchingMyReservation={fetchingMyReservation} myReservationData={myReservationData} editReservation={handleEditReservation} handleDelete={(bool) => handleDeleteReservation(bool)} />
                    </section>
                    : currentPage == 2 ?
                        <ResReservationV2_2 selectedVenueId={selectedVenueId} selectedVenueData={selectedVenueData} myReservationData={myReservationData} next={(reservationRequestData) => handleCreateReservation(reservationRequestData)}  goBack={() => handleGoBack()}/>
                    : currentPage == 3 ?
                        <ResReservationV2_success next={() => handleReservationSuccessNext()} />
                    : currentPage == 4 ?
                        <ResReservationV2_update selectedMyReservationData={selectedMyReservationData} proceedUpdateReservation={(updateReservationPayload) => proceedUpdateReservation(updateReservationPayload)} goBack={handleGoBack} />
                    : null
                }
            </section>
            {loading && <Loader displayMsg={displayLoadingMsg} />}
            {askDailyProgramAck && <DailyProgramAckPopupV2 askDailyProgramAckMsg={askDailyProgramAckMsg} proceed={handleDailyProgramAck} close={() => setAskDailyProgramAck(false)} /> }
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        allowWalkInGuestRestaurantBooking: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs.allowWalkInGuestRestaurantBooking : false,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { setGoHome, closeOrderPopUp, setRegPage, setLoginRequired, sendAnalytics })(withTranslation('translations')(ResReservationV2));
